/**
 * Global time formatter for evaluation UI
 * Handles: wait, estimated, progress, completed times
 */
export const TimeFormatter = (
    seconds,
    options = {}
  ) => {
    if (seconds == null || seconds === "NA") return "--";
  
    const total = Math.max(0, Math.round(Number(seconds)));
    if (!Number.isFinite(total)) return "--";
  
    const hrs = Math.floor(total / 3600);
    const mins = Math.floor((total % 3600) / 60);
    const secs = total % 60;
  
    // Short format: 2m 40s
    if (options.short) {
      if (hrs > 0) return `${hrs}h ${mins}m`;
      if (mins > 0) return `${mins}m ${secs}s`;
      return `${secs || 1}s`;
    }
  
    // Default readable format
    if (hrs > 0) {
      return mins > 0 ? `${hrs} hr ${mins} min` : `${hrs} hr`;
    }
  
    if (mins > 0) {
      return secs > 0 ? `${mins} min ${secs} sec` : `${mins} min`;
    }
  
    return `${secs || 1} sec`;
  };
  